import { Injectable } from '@angular/core';
import { HttpClient, HttpEventType,HttpHeaders } from '@angular/common/http';
import { TokenService } from '../../token.service';
import { MainService } from './main.service';

@Injectable({
  providedIn: 'root'
})
export class HrHierService {

  httpUrl;
  constructor(private http: HttpClient, private main: MainService, private token:TokenService) {
    this.httpUrl = this.main.httpUrl ;
  }
  httpUrl2=this.main.httpUrl

//API from Account Hier
  async deleteHierarchy(obj:any ) {
    const resp = await this.http.put<any>(this.httpUrl2 + '/accounts/hierarchies/project/deleteHierarchy' ,obj ).toPromise().then(res => {
      return res;
    });
    return resp;
  }
  async  projectupdateHierarchy(obj:any ) {
    const resp = this.http.put<any>(this.httpUrl2 + '/accounts/hierarchies/project/updateHierarchy',obj ).toPromise().then(res => {
      return res
    });
    return resp
  }
  async  getprojectHierarchy(obj:any ) {
    const resp = this.http.post<any>(this.httpUrl2 + '/accounts/hierarchies/project/getHierarchy',obj ).toPromise().then(res => {
      return res
    });
    return resp
  }
  async  createHierarchy(obj:any ) {
    const resp = this.http.post<any>(this.httpUrl2 +'/accounts/hierarchies/project/createHierarchy', obj  ).toPromise().then(res => {
      return res
    });
    return resp
  }
  async  getCost(obj:any ) {
    const resp = await this.http.post<any>(this.httpUrl2 + '/accounts/costCenter/getCostCenter' , obj  ).toPromise().then(res => {
      return res
    });
    console.log(resp)
    return resp
  }
  // async insertEmbHierarchyNode(obj:any ) {
  //   const resp = await this.http.post<any>(this.main.httpUrl + '/administration/embHier/insertEmbHierarchyNode' , obj  ).toPromise().then(res => {
  //     return res;
  //   });
  //   return resp;
  // }
  // async getAllEmbHierarchy(obj:any ) {
  //   const resp = await this.http.get<any>(this.main.httpUrl + '/administration/embHier/getAllEmbHierarchy' + obj).toPromise().then(res => {
  //     return res;
  //   });
  //   return resp;
  // }
//API from Account Hier

  async getAllHrHierarchy(obj:any ) {
    const resp = await this.http.get<any>(this.main.httpUrl + '/hr/setting/hrHier/getAllHrHierarchy' + obj ).toPromise().then(res => {
      return res;
    });
    return resp;
  }

  async insertHrHierarchyNode(obj:any ) {
    const resp = await this.http.post<any>(this.main.httpUrl + '/hr/setting/hrHier/insertHrHierarchyNode' , obj  ).toPromise().then(res => {
      return res;
    });
    return resp;
  }

  async updateHrHierarchyNode(obj:any ) {
    const resp = await this.http.put<any>(this.main.httpUrl + '/hr/setting/hrHier/updateHrHierarchyNode' , obj  ).toPromise().then(res => {
      return res;
    });
    return resp;
  }
  async deleteHrHierarchy(obj:any ) {
    const resp = await this.http.put<any>(this.main.httpUrl + '/hr/setting/hrHier/deleteHrHierarchy' , obj  ).toPromise().then(res => {
      return res;
    });
    return resp;
  }




  //data assign



  async getAllHrdataAssigned(obj:any ) {
    const resp = await this.http.get<any>(this.main.httpUrl + '/hr/setting/hrdataAssign/getAllHrdataAssigned' + obj ).toPromise().then(res => {
      return res;
    });
    return resp;
  }
  async insertHrdataAssign(obj:any ) {
    const resp = await this.http.post<any>(this.main.httpUrl + '/hr/setting/hrdataAssign/insertHrdataAssign' , obj  ).toPromise().then(res => {
      return res;
    });
    return resp;
  }
  async insertHrdataAssign1(obj:any ) {
    const resp = await this.http.post<any>(this.main.httpUrl + '/hr/setting/hrdataAssign/1insertHrdataAssign' , obj  ).toPromise().then(res => {
      return res;
    });
    return resp;
  }

  async updateHrdataAssign(obj:any ) {
    const resp = await this.http.put<any>(this.main.httpUrl + '/hr/setting/hrdataAssign/updateHrdataAssign' , obj  ).toPromise().then(res => {
      return res;
    });
    return resp;
  }

  async getuserAssigneddata(obj:any ) {
    const resp = await this.http.get<any>(this.main.httpUrl + '/hr/setting/hrdataAssign/getuserAssigneddata'+obj ).toPromise().then(res => {
      return res;
    });
    return resp;
  }
}
